import loadScript from './load_script';
import regions from '../../config/riot_regions';
import statsTracker from './stats_tracker';

const ENABLED_SHARDS = process.env.ENABLED_SHARDS.split(',');

const languageNames = {
  'en' : 'English',
  'de' : 'Deutsch',
  'es' : 'Español',
  'fr' : 'Français',
  'it' : 'Italiano',
  'pl' : 'Polski',
  'ru' : 'Русский',
  'pt' : 'Português',
  'el' : 'Ελληνικά',
  'ro' : 'Română',
  'tr' : 'Türkçe',
  'hu' : 'Magyar',
  'cs' : 'Čeština',
  'ko' : '한국어',
  'ja' : '日本語'
};

const addConfig = () => {
  window.riotBarConfig = {
    locale: {
      locales: {}
    },
    mobileResponsive: true,
    touchpoints: {
      activeTouchpoint: 'support'
    }
  };

  ENABLED_SHARDS.forEach(shard => {
    if(!window.riotBarConfig.locale.locales[shard])
      window.riotBarConfig.locale.locales[shard] = [];

    regions.shards[shard].languages.forEach(locale => {
      const language = locale.split('_')[0];

      window.riotBarConfig.locale.locales[shard].push({
        landingUrl: `//${process.env.PUBLIC_DOMAIN.replace('{shard}', shard)}/${language}/`,
        locale: locale,
        lang: language,
        languageName: languageNames[language]
      });
    });
  });

  return new Promise((resolve, reject) => {
    window.riotBarConfig.onLoad = resolve;
  });
}

export const loadRiotBar = (locale) => {
	const loadPromise = addConfig();

  return loadScript(`//s.lolstatic.com/riotbar/prod/latest/${locale}.js`).then(() => {
    return loadPromise;
  }).then(() => {
    //Attempt to track clicks on the login button. This is probably a waste of time because
    //the riotbar doesn't offer any event hooks into links being clicked, so we have no way to
    //inject our own tracking in a way that will allow the tracking to complete recording prior
    //to the window.location being changed by the riotbar.
    //source: https://gh.riotgames.com/web/riotbar/blob/master/src/plugins/account/extensions.js
    if(document.querySelector) {
      const loginButton = document.querySelector('[data-riotbar-link-id=login]');
      if(loginButton) {
        loginButton.addEventListener('click', () => statsTracker.trackEvent('click', 'login'));
      }
    }
  });
}


// WEBPACK FOOTER //
// ./src/utils/riotbar.js